/**
 * 科目学分记录
 * @author wql
 * @date 2020-10-22
 */
import React from 'react';
import {connect} from 'dva';

import {component_tool, framework_tool, utils_tool} from '@/tool';
import {modelUtils} from '@/utils';
import {Descriptions} from "antd";
import {dealerColumns, personColumns, dealerExcelColumns, personExcelColumns} from './columns'
import {WizTableForm} from '@/containers/common';
import moment from "moment";
import SubjectCreditPersonImport from "./subjectCreditPerson/subjectCreditPersonImport";
import SubjectCreditDealerImport from "./subjectCreditDealer/subjectCreditDealerImport";

let {Session, getPageData} = utils_tool;
let {
  WizButton, WizRow, WizCol, WizTable, WizCard, WizSpin, WizForm, WizTabs,
  WizTag, WizModal, WizSearchBar, WizDataTable,WizBrowserExport
} = component_tool;
let {WizContainer, ossFileUtils} = framework_tool;

const getSubjectRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/credit/subjectList/subjectCreditRecordList') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('subjectRecordInfo', record)
      } else {
        record = Session.get('subjectRecordInfo') || 0
      }
    }
  } else {
    record = Session.get('subjectRecordInfo') || 0
  }
  return record
}

class SubjectCreditRecordList extends WizContainer {

  componentName = 'subjectCreditRecordList';

  constructor(props) {
    super(props);
    this.state = {
      apiParams: {},
      personalList: [],
      dealerList: [],
      visible: false,
      modelName: '',
      personalInfo: {},
      dealerInfo: {},
      dealerVisible: false,
      dealerModelName: '',
      personImportVisible: false,
      dealerImportVisible: false,
      currentTabKey: 'subjectCredit_person',
      entityType: 1,
      importKey:new Date().getTime(),
      record : {},
    }
    this.initialValue = getSubjectRecord(props.history);
  }

  _componentDidMount() {
    if (this.initialValue && this.initialValue.id) {
      this._getPersonalList()
      this._getDealerList()
    }
  }

  propsAndStateOnChange = {
    cmd: this._handleCMD.bind(this),
    getDealerList: this._getDealerListHandle.bind(this),
    getPersonalList: this._getPersonalListHandler.bind(this),
    getDealerById: this.getDealerByIdHandle.bind(this),
    importSubjectCreditFile: this._handleImport.bind(this),
    subjectCreditPersonExcelFile: this._handlePersonFile.bind(this),
    subjectCreditDealerExcelFile: this._handleDealerFile.bind(this),
  };

  getDealerByIdHandle(nextProps, nextState) {
    let o = nextProps.getDealerById;
    let dealerInfo = this.state.dealerInfo;
    if (o['success']) {
      let data = o.data;
      dealerInfo.brandName = data.brandName;
      dealerInfo.areaName = data.areaName;
      dealerInfo.dealerState = data.dealerState == '已开店' ? 1 : data.dealerState == '已关店' ? 0 : 2;
      dealerInfo.preSalesNumber = data.preSalesNumber;
      dealerInfo.afterSalesNumber = data.afterSalesNumber;
      dealerInfo.entityId = data.id
      dealerInfo.orgId = data.orgId
      nextState.dealerInfo = dealerInfo;
      return true;
    }
  }

  _handleImport(nextProps, nextState) {
    let o = nextProps['importSubjectCreditFile']
    const {entityType} = this.state;
    if (o['success']) {
      wizNotice.success(o['msg'])
      if (entityType && entityType === 1) {
        this.setState({personImportVisible: false})
        this._getPersonalList()
      } else {
        this.setState({
          dealerImportVisible: false,
          importKey:new Date().getTime(),
        })
        this._getDealerList()
      }
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleCMD(nextProps, nextState) {
    let o = nextProps.cmd;
    if (o['success']) {
      wizNotice.success(o['msg'])
      // nextState.getPathInfo = o.data
      this._getPersonalList()
      this._getDealerList()
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleDealerFile(nextProps, nextState) {
    let o = nextProps.subjectCreditDealerExcelFile;
    let columns = dealerExcelColumns;
    if (o['success']) {
      let data = o['data'];
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _data.push(_d);
      });
      WizBrowserExport({
        title: '店端科目学分信息',
        sheetName: '店端科目学分信息',
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: '店端科目学分信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handlePersonFile(nextProps, nextState) {
    let o = nextProps.subjectCreditPersonExcelFile;
    let columns = personExcelColumns;
    if (o['success']) {
      let data = o['data'];
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _data.push(_d);
      });
      WizBrowserExport({
        title: '个人科目学分信息',
        sheetName: '个人科目学分信息',
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: '个人科目学分信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getDealerListHandle(nextProps, nextState) {
    let o = nextProps.getDealerList;
    if (o['success']) {
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getPersonalListHandler(nextProps, nextState) {
    let o = nextProps.getPersonalList;
    if (o['success']) {
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getPersonalList(other = {}) {
    this.doActions([
      {
        path: 'subjectCreditRecord/pageList',
        payload: {
          key: 'getPersonalList',
          apiParams: {
            ...this.state.apiParams, ...other,
            subjectId: this.initialValue.id,
            entityType: 1,
          }
        }
      },
    ]);
  }

  _getDealerList(other = {}) {
    this.doActions([
      {
        path: 'subjectCreditRecord/pageList',
        payload: {
          key: 'getDealerList',
          apiParams: {
            ...this.state.apiParams, ...other,
            subjectId: this.initialValue.id,
            entityType: 2,
          }
        }
      },
    ]);
  }

  getDealerById(value) {
    this.doActions([
      {
        path: 'subjectCreditRecord/getDealerById',
        payload: {
          key: 'getDealerById',
          apiParams: {id: value}
        }
      },
    ]);
  }

  _getPersonalExcelList(other = {}) {
    this.doActions([
      {
        path: 'subjectCreditRecord/personExport',
        payload: {
          key: 'subjectCreditPersonExcelFile',
          apiParams: {
            ...this.state.apiParams, ...other,
            subjectId: this.initialValue.id,
            entityType: 1,
          }
        }
      },
    ]);
  }

  _getDealerExcelList(other = {}) {
    this.doActions([
      {
        path: 'subjectCreditRecord/dealerExport',
        payload: {
          key: 'subjectCreditDealerExcelFile',
          apiParams: {
            ...this.state.apiParams, ...other,
            subjectId: this.initialValue.id,
            entityType: 2,
          }
        }
      },
    ]);
  }

  openModel(val) {
    let name = '';
    if (val.id == null && val.entityType == 1) {
      name = '新增个人学分记录'
    } else if (val.id == null && val.entityType == 2) {
      name = '新增店端学分记录'
    } else if (val.id != null && val.entityType == 1) {
      name = '编辑个人学分记录'
    } else if (val.id != null && val.entityType == 2) {
      name = '编辑店端学分记录'
    }
    this.setState({
      modelName: name,
      visible: true,
      personalInfo: val
    });
  }

  openDealerModel(val) {
    let name = '';
    let record = this.state.record;
    if (val.id == null && val.entityType == 1) {
      name = '新增个人学分记录'
    } else if (val.id == null && val.entityType == 2) {
      name = '新增店端学分记录'
      record.id = new Date();
    } else if (val.id != null && val.entityType == 1) {
      name = '编辑个人学分记录'
    } else if (val.id != null && val.entityType == 2) {
      name = '编辑店端学分记录'
    }
    this.setState({
      dealerModelName: name,
      dealerVisible: true,
      dealerInfo: val,
      record : record
    });
  }


  _columns = (config) => {
    return [
      {
        formItem: {
          type: "hidden",
        },
        name: "id"
      },
      {
        title: "选择学员",
        name: "entityId",
        formItem: {
          ...config,
          diy: WizTableForm,
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择学员'
          }],
          onChange: (form, value, rows) => {
            let data = rows[0];
            this.state.personalInfo.userName = data.userName
            this.state.personalInfo.idCard = data.idCard
            this.state.personalInfo.mobile = data.mobile
            this.state.personalInfo.accountState = data.state
          },
        },
      },
      // {
      //   title: "账号",
      //   name: "userName",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <>{this.state.personalInfo.userName}</>
      //     }
      //   },
      // },
      // {
      //   title: "身份证号",
      //   name: "idCard",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div>{this.state.personalInfo.idCard}</div>
      //     }
      //   },
      // },
      // {
      //   title: "手机号",
      //   name: "mobile",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div>{this.state.personalInfo.mobile}</div>
      //     }
      //   },
      // },
      // {
      //   title: "账号状态",
      //   name: "accountState",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div>{this.state.personalInfo.accountState == 0 ? '禁用' : this.state.personalInfo.accountState == 1 ? '激活' : ''}</div>
      //     }
      //   },
      // },
      {
        title: "分数",
        name: "score",
        formItem: {
          type: 'number',
          min:0,
          rules: [{
            required: true,
            message: '请输入分数'
          }],
        },
      },
      {
        title: "获得时间",
        name: "gainTime",
        formItem: {
          type: "date",
          rules: [{
            required: true,
            message: '请输入获得时间'
          }],
        }
      },
      {
        title: "获得途径",
        name: "channel",
        formItem: {
          maxlength: 20,
          links: {'entityId': '任务内容'},
          rules: [{
            required: true,
            message: '请输入获得途径'
          }],
        },
      },
      {
        title: "状态",
        name: "state",
        formItem: {
          type: 'radio',
          initialValue: 1,
          dict: [
            {code: 1, codeName: "有效"},
            {code: 0, codeName: "无效"}
          ],
        },
      }
    ]
  }

  getTaskModal() {
    let config = {};
    config.type = 'diy';
    config.columns = this.userColumns();
    config.initialValue = [];
    config.rowName = 'fullName';
    config.rowTitle = 'userName';
    config.rowKey = 'personId';
    config.tableApi = {path: 'subject/queryPersonInfo',apiParams: {id: this.initialValue.id,state:1}}
    let columns = this._columns(config)
    let data = this.state.personalInfo;
    if (data.id != null) {
      let newColumn = {
        title: "选择学员",
        name: "entityId",
        formItem: {
          type: 'custom',
          render: () => {
            return <div>{this.state.personalInfo.fullName}</div>
          },
        },
      }
      columns.splice(1, 1, newColumn)
    } else {
      data.state = 1
    }
    let onSubmit = this._saveTask.bind(this);
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: data,
      preview: null,
      footer: false,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }
    return formProps;
  }

  _dealerColumns = (dealerConfig) => {
    return [
      {
        formItem: {
          type: "hidden",
        },
        name: "id"
      },
      {
        title: "选择组织",
        name: "entityId",
        formItem: {
          ...dealerConfig,
          diy: WizTableForm,
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择组织'
          }],
          onChange: (form, value, rows) => {
            this.state.dealerInfo.entityId = rows[0].businessId;
            // this.getDealerById(rows[0].businessId);
          },
        },
      },
      // {
      //   title: "品牌",
      //   name: "brandName",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div>{this.state.dealerInfo.brandName}</div>
      //     }
      //   },
      // },
      // {
      //   title: "区域",
      //   name: "areaName",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div>{this.state.dealerInfo.areaName}</div>
      //     }
      //   },
      // },
      // {
      //   title: "销售代码",
      //   name: "preSalesNumber",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div>{this.state.dealerInfo.preSalesNumber}</div>
      //     }
      //   },
      // },
      // {
      //   title: "售后代码",
      //   name: "afterSalesNumber",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div>{this.state.dealerInfo.afterSalesNumber}</div>
      //     }
      //   },
      // },
      // {
      //   title: "开店状态",
      //   name: "dealerState",
      //   formItem: {
      //     type: 'custom',
      //     render: () => {
      //       return <div>{this.state.dealerInfo.dealerState == 0 ? '已关店' : this.state.dealerInfo.dealerState == 1 ? '已开店' : this.state.dealerInfo.dealerState == 2 ? '建设中': ''}</div>
      //     }
      //   },
      // },
      {
        title: "分数",
        name: "score",
        formItem: {
          type: 'number',
          min:0,
          rules: [{
            required: true,
            message: '请输入分数'
          }],
        },
      },
      {
        title: "获得时间",
        name: "gainTime",
        formItem: {
          type: "date",
          rules: [{
            required: true,
            message: '请输入获得时间'
          }],
        }
      },
      {
        title: "获得途径",
        name: "channel",
        formItem: {
          maxlength: 20,
          links: {'entityId': '任务内容'},
          rules: [{
            required: true,
            message: '请输入获得途径'
          }],
          // initialValue: this.state.taskColumns.name,
        },
      },
      {
        title: "状态",
        name: "state",
        formItem: {
          type: 'radio',
          dict: [
            {code: 1, codeName: "有效"},
            {code: 0, codeName: "无效"}
          ],
        },
      }
    ]
  }

  getDealerModal() {
    let dealerConfig = {};
    dealerConfig.type = 'diy';
    dealerConfig.columns = this.dealerColumns();
    dealerConfig.initialValue = [];
    dealerConfig.tableApi = {path: 'subject/queryOrgInfo',apiParams: {id: this.initialValue.id,state:1}}
    let data = this.state.dealerInfo;
    let columns = this._dealerColumns(dealerConfig)
    if (data.id != null) {
      let newColumn = {
        title: "选择组织",
        name: "entityId",
        formItem: {
          type: 'custom',
          render: () => {
            return <div>{this.state.dealerInfo.dealerName}</div>
          },
        },
      }
      columns.splice(1, 1, newColumn)
    } else {
      data.state = 1
    }
    let onSubmit = this._saveTask.bind(this);
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: data,
      preview: null,
      footer: false,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }
    return formProps;
  }

  /** 学员科目学分导入 */
  _personImportModal() {
    return <WizModal key={this.state.importKey+'_person_modal'}
                     width={900} title={"导入个人科目学分"}
                     visible={this.state.personImportVisible}
                     onCancel={() => this._changeVisible('personImportVisible', false)}
                     footer={null}
    >
      <SubjectCreditPersonImport key={this.state.importKey + '_personImport'}
                                 importSubjectCredit={this.importSubjectCredit.bind(this)}/>
    </WizModal>
  }

  /** 店端科目学分导入 */
  _dealerImportModal() {
    return <WizModal key={this.state.importKey+'_dealer_modal'}
                     width={900} title={"导入店端科目学分"}
                     visible={this.state.dealerImportVisible}
                     onCancel={() => this._changeVisible('dealerImportVisible', false)}
                     footer={null}
    >
      <SubjectCreditDealerImport key={this.state.importKey + '_dealerImport'}
                                 importSubjectCredit={this.importSubjectCredit.bind(this)}/>
    </WizModal>
  }

  /**
   * 科目学分导入
   * @param other
   */
  importSubjectCredit(other = {}) {
    const {entityType} = this.state;
    let initialValue = this.initialValue;
    this.doAction({
      path: 'subjectCreditRecord/import',
      payload: {
        key: 'importSubjectCreditFile',
        apiParams: {
          ...other,
          subjectId: initialValue.id,
          entityType: entityType
        }
      },
      autoInit: true,
    })
  }

  /**会话框开关 */
  _changeVisible(key, value) {
    this.setState({
      [key]: value
    })
  }

  _onChangeTab(activeKey) {
    let entityType = activeKey && activeKey === 'subjectCredit_person' ? 1 : 2;
    this.setState({
      entityType: entityType,
      apiParams: {},
    })
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (entityType, visibleName) => {
    let r = []
    let btns = new Map();
    btns.set('add', <WizButton className="report-button" icon='plus' type='primary' title="新增" onClick={e => this.openModel({entityType})}>新增</WizButton>);
    btns.set('import', <WizButton type='export' title="导入" onClick={e => {this._changeVisible(visibleName, true) }}>导入</WizButton>);
    btns.set('export',
      <WizButton type='export' title="导出" onClick={() => {
        if (entityType === 1) {
          this._getPersonalExcelList()
        }
        if (entityType === 2) {
          this._getDealerExcelList()
        }
      }}>导出</WizButton>);
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }

  _render() {
    const {getDealerList, getPersonalList} = this.props;
    let personalDataItems = getPageData(getPersonalList.data);
    let other = {};
    let personalColumns = personColumns(this, personalDataItems, other);
    let personalSearchBarProps = {
      columns: personalColumns,
      onSearch: values => {
        values.subjectId = this.initialValue.id
        values.entityType = 1;
        if (values['gainTime'] && values['gainTime'].length === 2) {
          values['gainTimeStart'] = moment(values['gainTime'][0]).format("YYYY-MM-DD") + ' 00:00:00';
          values['gainTimeEnd'] = moment(values['gainTime'][1]).format("YYYY-MM-DD") + ' 23:59:59';
        }
        // delete values['gainTime']
        this.setState({apiParams: values}, () => {
          this._getPersonalList();
        })
      },
    };
    let personalDataTableProps = {
      columns: personalColumns,
      rowKey: "id",
      dataItems: personalDataItems,
      showNum: false,
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        this._getPersonalList({current: pageNum, size: pageSize});
      }
    }
    let dataItems = getPageData(getDealerList.data);
    let columns = dealerColumns(this, dataItems, other);
    let searchBarProps = {
      columns: columns,
      onSearch: values => {
        values.subjectId = this.initialValue.id
        values.entityType = 2;
        if (values['gainTime'] && values['gainTime'].length === 2) {
          values['gainTimeStart'] = moment(values['gainTime'][0]).format("YYYY-MM-DD") + ' 00:00:00';
          values['gainTimeEnd'] = moment(values['gainTime'][1]).format("YYYY-MM-DD") + ' 23:59:59';
        }
        // delete values['gainTime']
        this.setState({apiParams: values}, () => {
          this._getDealerList();
        })
      }
    };
    let dataTableProps = {
      columns: columns,
      rowKey: "id",
      dataItems,
      showNum: false,
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        this._getDealerList({current: pageNum, size: pageSize});
      }
    }
    let dealerKey = this.initialValue.id + '_' + this.state.record.id + '_' + this.state.record.state;
    return (
      <>
        <WizSpin tip={'加载中'} spinning={this.props.loading}>
          <WizCard title={'科目信息'}>
            <WizRow key={'trainPath-info'}>
              <WizCol span={3}></WizCol>
              <WizCol span={8}>
                <Descriptions key={'trainPath-descriptions'} column={1}>
                  <Descriptions >名称：{this.initialValue.name}</Descriptions>
                  <Descriptions>类型：{this.initialValue.type && this.initialValue.type == 1 ? '必修' : this.initialValue.type ? '选修' : ''}</Descriptions>
                </Descriptions>
              </WizCol>
              <WizCol span={10}>
                <Descriptions key={'trainPath-descriptions'} column={1}>
                  <Descriptions>分类：{this.initialValue.categoryName}</Descriptions>
                  <Descriptions>状态：{this.initialValue.state == 0 ? '无效' : '有效'}</Descriptions>
                </Descriptions>
              </WizCol>
            </WizRow>
            <WizRow key={'trainPath-info'}>
              <WizCol span={3}></WizCol>
              <WizCol span={16}>
                <Descriptions key={'trainPath-descriptions'} column={1}>
                  <Descriptions>介绍：{this.initialValue.intro}</Descriptions>
                </Descriptions>
              </WizCol>
            </WizRow>
          </WizCard>
          <WizCard>
            <WizTabs animated={false} onChange={(activeKey) => {
              this._onChangeTab(activeKey)
            }}>
              <WizTabs.TabPane tab="个人记录" key={'subjectCredit_person'}>
                <WizSearchBar
                  type="grid" key={'subjectCredit_person_search'}
                  btnAccessCheck={false}
                  {...personalSearchBarProps}
                />
                <WizButton.WizGroup>
                  {this._renderBtn(1,'personImportVisible')}
                </WizButton.WizGroup>
                {this._personImportModal()}
                <WizDataTable {...personalDataTableProps} />
                <div className='pagination'>
                  <WizDataTable.Pagination {...personalDataTableProps} />
                </div>
              </WizTabs.TabPane>

              <WizTabs.TabPane tab="店端记录" key={'subjectCredit_dealer'}>
                <WizSearchBar
                  type="grid" key={'subjectCredit_dealer_search'}
                  {...searchBarProps}
                />
                <WizButton.WizGroup>
                  {this._renderBtn(2,'dealerImportVisible')}
                </WizButton.WizGroup>
                {this._dealerImportModal()}
                <WizDataTable {...dataTableProps} />
                <div className='pagination'>
                  <WizDataTable.Pagination {...dataTableProps} />
                </div>
              </WizTabs.TabPane>
            </WizTabs>
          </WizCard>

          <WizModal key={new Date()} title={this.state.modelName} visible={this.state.visible}
                    onOk={this.handleOk.bind(this)} onCancel={this.handleCancel.bind(this)} width={700}>
            <WizSpin tip={'加载中'} spinning={this.props.loading}>
              <WizForm className={'form-inline'} {...this.getTaskModal()} ref={r => {
                this.ref = r;
              }}></WizForm>
            </WizSpin>
          </WizModal>

          <WizModal key={dealerKey} title={this.state.dealerModelName} visible={this.state.dealerVisible}
                    onOk={this.dealerHandleOk.bind(this)} onCancel={this.dealerHandleCancel.bind(this)} width={700}>
            <WizSpin tip={'加载中'} spinning={this.props.loading}>
              <WizForm className={'form-inline'} {...this.getDealerModal()} ref={r => {
                this.ref = r;
              }}></WizForm>
            </WizSpin>
          </WizModal>

        </WizSpin>
      </>
    );
  }

  /**
   * 保存和更新
   * @param values
   * @private
   */
  _saveTask(values) {
    let gainTime = moment(values.gainTime).format('YYYY-MM-DD HH:mm:ss');
    values.gainTime = gainTime;

    let apiPath = '';
    if (values.id) {
      // delete values.entityId
      apiPath = "subjectCreditRecord/upd"
    } else {
      apiPath = "subjectCreditRecord/add";
      values.subjectId = this.initialValue.id
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: 'cmdHandler',
        apiParams: {
          ...values
        }
      }
    });
  }

  handleOk = e => {
    this.ref.validateFields((err, values) => {
      if (!err) {
        values.entityType = 1;
        this._saveTask(values);
        this.setState({
          visible: false,
        });
      }
      return
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  dealerHandleOk = e => {
    this.ref.validateFields((err, values) => {
      if (!err) {
        values.entityType = 2;
        values.entityId = this.state.dealerInfo.entityId
        this._saveTask(values);
        this.setState({
          dealerVisible: false,
        });
      }
      return
    });
  };

  dealerHandleCancel = e => {
    this.setState({
      dealerVisible: false,
    });
  };

  updateState(value) {
    this.state.record = value;
    let ids = [];
    ids.push(value.id);
    let state = value.state == 1 ? 0 : 1
      const content = `您确定要${
        value.state === 0 ? "启用" : "禁用"
      }该学分记录吗？`;
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          this.doActions([
            {
              path: 'subjectCreditRecord/updateState',
              payload: {
                key: 'cmdHandler',
                apiParams: {
                  ids: ids,
                  state: state
                }
              }
            },
          ]);
        },
        onCancel() {
        }
      });
  }

  userColumns () {
    return [
      {
        title: '账号',
        name: 'userName',
        dataIndex: 'userName',
        searchItem: {},
        tableItem: {}
      },
      {
        title: '姓名',
        name: 'fullName',
        dataIndex: 'fullName',
        searchItem: {},
        tableItem: {}
      },
      {
        title: '证件号码',
        name: 'idCard',
        dataIndex: 'idCard',
        searchItem: {},
        tableItem: {}
      },
      {
        title: '手机号',
        name: 'mobile',
        dataIndex: 'mobile',
        tableItem: {}
      },
      {
        title: '状态',
        name: 'state',
        dataIndex: 'state',
        dict: [
          { code: 1, codeName: '激活' },
          { code: 0, codeName: '禁用' },
        ],
        searchItem: {
          type: 'select',
          width: 171
        },
        tableItem: {}
      }
    ]
  }

  dealerColumns () {
    return [
      {
        title: '组织名称',
        name: 'name',
        tableItem: {
          width: '250px'
        },
        searchItem: {}
      },
      {
        title: '组织编码',
        name: 'code',
        tableItem: {
          width: '250px'
        },
        searchItem: {}
      },
      {
        title: '组织类型',
        name: 'organizationNodeCategoryName',
        tableItem: {
          width: '200px'
        }
      },
      {
        title: '组织状态',
        name: 'state',
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' },
        ],
        tableItem: {}
      }
    ]
  }
}

const mapStateToProps = (state, ownProps) => {
  const {subjectCreditRecord} = state;
  const cmd = modelUtils.getModelEntity(subjectCreditRecord, "cmdHandler");
  const getDealerList = modelUtils.getModelEntity(subjectCreditRecord, "getDealerList");
  const getPersonalList = modelUtils.getModelEntity(subjectCreditRecord, "getPersonalList");
  const getDealerById = modelUtils.getModelEntity(subjectCreditRecord, "getDealerById");
  const importSubjectCreditFile = modelUtils.getModelEntity(subjectCreditRecord, "importSubjectCreditFile");
  const subjectCreditPersonExcelFile = modelUtils.getModelEntity(subjectCreditRecord, "subjectCreditPersonExcelFile");
  const subjectCreditDealerExcelFile = modelUtils.getModelEntity(subjectCreditRecord, "subjectCreditDealerExcelFile");
  const load = modelUtils.getLoadingState(state, 'subjectCreditRecord');
  let loading = load.subjectCreditRecordLoading
  return {
    cmd,
    importSubjectCreditFile,
    subjectCreditPersonExcelFile,
    subjectCreditDealerExcelFile,
    getDealerList,
    getPersonalList,
    getDealerById,
    loading
  };
};

export default connect(mapStateToProps)(SubjectCreditRecordList);
